import { useQuery } from "@tanstack/react-query";
import { queueApiService } from "@/services/queueApi.service";

export const useDashboard = (startDate: string, endDate: string) => {
  return useQuery({
    queryKey: ["dashboard", startDate, endDate],
    queryFn: () =>
      queueApiService.getDashboardData({
        start: startDate,
        end: endDate,
      }),
    enabled: !!startDate && !!endDate,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
